module.exports = __webpack_public_path__ + "media/images/flags/32/Australia-2d99d1ba6cc7177a15bf181c1de6fcf5.png";